<template>

    <form ref="ajudaperguntameucna-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="pergunta">Pergunta</label>
                <input type="text" class="form-control" name="pergunta" placeholder="Pergunta" v-model="model.pergunta" required />
            </div>
            <div class="form-group col-md-12">
                <label for="resposta">Resposta</label>
                <textarea class="form-control" name="resposta" placeholder="Resposta" v-model="model.resposta" v-htmleditor required></textarea>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativa" class="custom-control-input" v-model="model.ativa">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativa?</span>
                </label>
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "ajudaperguntameucna-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "ajudaperguntameucna-form-create",

            resources: {
                create: 'ajudaperguntameucna',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

